import { defineComponent, nextTick } from 'vue'

type AnimationStates = {
  standard: { 'transition-timing-function': 'var(--trans-standard)' }
  decelerate: { 'transition-timing-function': 'var(--trans-decelerate)' }
}

/**
 * @deprecated just don't use this, as of today (11/04/2024) this is probaly more than **5 years old** and a terrible thing to import.
 * Do yourself a favor. Just use tailwind
 */
export default defineComponent({
  data() {
    return {
      /**
       * @deprecated don't use this.
       */
      states: {
        standard: { 'transition-timing-function': 'var(--trans-standard)' },
        decelerate: { 'transition-timing-function': 'var(--trans-decelerate)' },
      },
      /**
       * @deprecated don't use this.
       */
      aniSpeed: 0.15,
      /**
       * @deprecated don't use this.
       */
      selectedAniState: 'standard',
    }
  },
  computed: {
    /**
     * @deprecated don't use this.
     */
    anistate() {
      const ret = this.states[this.selectedAniState as keyof AnimationStates]

      if (!ret) return {}
      else {
        // @ts-expect-error
        ret['transition-duration'] = this.aniSpeed + 's'
        return ret
      }
    },
  },
  methods: {
    /**
     * @deprecated don't use this.
     */
    changeAniSate(state: keyof AnimationStates, cb?: Function) {
      if (this.states[state] === undefined)
        console.warn(state + ' is not a valid anistate')

      this.selectedAniState = state
      nextTick(() => {
        if (typeof cb === 'function') cb()
      })
    },
  },
})
